// src/components/Card.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';

function Card({ path, label, description }) {
    return (
        <div className="admin-card">
            <h3>{label}</h3>
            <p>{description}</p>
            <Link to={path} className="button button-m">
                管理
            </Link>
        </div>
    );
}

export default Card;